import React from 'react';
import { useSelector } from 'react-redux';

import { AddressVerificationContainer } from '../styles';
import { getSgkycFlowRfiData } from '@Redux/selectors';
import ManualDocumentUpload from '../../../user-flow/individual/revampedUserFlow/manualDocumentUpload';
import { POA_SELECTED_PAGE } from '../utils';

export const PoaSelectedUploadPage: React.FC = () => {
  const sgKycFlowData = useSelector(getSgkycFlowRfiData);
  const selectedAddressDoc = sgKycFlowData?.selectedAddressDoc;
  const { heading } = POA_SELECTED_PAGE;

  return (
    <AddressVerificationContainer>
      <div className="heading">{heading}</div>
      {selectedAddressDoc ? (
        <ManualDocumentUpload
          isSgKycRfi={true}
          sgKycDocumentList={[selectedAddressDoc]}
          isSgKycPoaUploadPage
        />
      ) : null}
    </AddressVerificationContainer>
  );
};
